/**
 * Unit validation and permission checks
 */

import { supabase } from '../supabase'

/**
 * Check if unit slug already exists (globally unique now)
 */
export async function isUnitSlugAvailable(slug: string): Promise<boolean> {
  const { data, error } = await supabase
    .from('units')
    .select('id')
    .eq('slug', slug)
    .maybeSingle()

  if (error) throw error
  return !data
}

/**
 * Check if user is unit admin (admin/manager OR creator)
 */
export async function isUnitAdmin(unitId: string, userId: string): Promise<boolean> {
  // creator check
  const { data: unit, error: unitError } = await supabase
    .from('units')
    .select('created_by')
    .eq('id', unitId)
    .maybeSingle()

  if (!unitError && unit?.created_by === userId) return true

  // member role check
  const { data, error } = await supabase
    .from('unit_members')
    .select('role')
    .eq('unit_id', unitId)
    .eq('user_id', userId)
    .maybeSingle()

  if (error || !data?.role) return false
  return ['admin', 'manager'].includes(data.role)
}
